/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogStorageMinerListRequest = {
    sortField?: ZerogStorageMinerListRequest.sortField;
    sortDirection?: ZerogStorageMinerListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace ZerogStorageMinerListRequest {

    export enum sortField {
        REWARD = 'REWARD',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

